<template>
    <div>
        <b-modal
            id="studentTask"
            title="Envios das Redações"
            size="lg"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">

                <div v-if="task">
                    <b-table
                        :items="students"
                        :fields="fields"
                        empty-text="Não encontramos nenhum resultado na busca :("
                        class="bg-white"
                        stacked="md"
                        :sticky-header="true"
                        show-empty
                        bordered
                        hover>


                        <template v-slot:cell(status)="row" >

                            <span v-if="row.item.essays.length > 0" class="text-success">
                                <span v-b-tooltip.hover :title="row.item.essays[0].finished_sending | moment('from', 'now')">
                                    Sim
                                </span>
                            </span>
                            <span v-else class="text-danger">
                                Não
                            </span>

                        </template>

                        <template v-slot:cell(correction)="row">

                            <span v-if="row.item.essays.length > 0">

                                <span v-if="row.item.essays[0].status === 'OKAY'" class="text-success">
                                    <span v-b-tooltip.hover :title="row.item.essays[0].finished_correction | moment('from', 'now')">
                                        Sim
                                    </span>
                                </span>
                                <span v-else class="text-danger">
                                    Não
                                </span>

                            </span>
                            <span v-else>
                                ---
                            </span>

                        </template>

                    </b-table>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            task: null,
            id: null,
            students: [],
            fields: [
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'email', label: 'Email', sortable: true },
                { key: 'status', label: 'Enviada ?'},
                { key: 'correction', label: 'Corrigida ?'}
            ],
        }
    },
    created() {

        this.$root.$on('studentsTask', (task) => {
            this.task = task;
            this.id = task.id;
            this.$bvModal.show('studentTask')
            this.load()
        })

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/teacher/tasks/' + this.id + '/students')
                .then((result) => {
                    this.students = result.data.data.students;
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
